function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { AgfNielsenMetaAdapter } from '../agf-nielsen-meta-adapter';
import { PlaybackType } from '../../../../core/player/playout-data';
import { AgfNielsenBrowserSdkEvents, DomlessNielsenSdkEvents } from '../../../reporting/agf-nielsen/agf-nielsen.enums';
export var AgfNielsenBrowserSdkClient = /*#__PURE__*/ function() {
    "use strict";
    function AgfNielsenBrowserSdkClient(agfNielsenSdkInstance) {
        var isIon = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        _class_call_check(this, AgfNielsenBrowserSdkClient);
        _define_property(this, "agfNielsenSdkInstance", void 0);
        _define_property(this, "isIon", void 0);
        _define_property(this, "domlessNielsenSdkInstance", void 0);
        _define_property(this, "normalisePlayerPosition", void 0);
        this.agfNielsenSdkInstance = agfNielsenSdkInstance;
        this.isIon = isIon;
        this.normalisePlayerPosition = function(position) {
            return Math.floor(position);
        };
        this.initializeDomlessNielsenSdkInstance();
    }
    _create_class(AgfNielsenBrowserSdkClient, [
        {
            key: "focus",
            value: function focus(timestamp) {
                if (this.isIon) {
                    var _this_domlessNielsenSdkInstance;
                    (_this_domlessNielsenSdkInstance = this.domlessNielsenSdkInstance) === null || _this_domlessNielsenSdkInstance === void 0 ? void 0 : _this_domlessNielsenSdkInstance.processEvent({
                        type: 'focus',
                        timestamp: timestamp
                    });
                }
            }
        },
        {
            key: "blur",
            value: function blur(timestamp) {
                if (this.isIon) {
                    var _this_domlessNielsenSdkInstance;
                    (_this_domlessNielsenSdkInstance = this.domlessNielsenSdkInstance) === null || _this_domlessNielsenSdkInstance === void 0 ? void 0 : _this_domlessNielsenSdkInstance.processEvent({
                        type: 'blur',
                        timestamp: timestamp
                    });
                }
            }
        },
        {
            key: "appClose",
            value: function appClose(timestamp) {
                if (this.isIon) {
                    var //cspell:disable-next-line
                    _this_domlessNielsenSdkInstance;
                    (_this_domlessNielsenSdkInstance = this.domlessNielsenSdkInstance) === null || _this_domlessNielsenSdkInstance === void 0 ? void 0 : _this_domlessNielsenSdkInstance.processEvent({
                        type: 'appclose',
                        timestamp: timestamp
                    });
                }
            }
        },
        {
            key: "setPlayheadPosition",
            value: function setPlayheadPosition(playerPosition) {
                if (playerPosition) {
                    var normalizedPosition = this.normalisePlayerPosition(playerPosition);
                    if (this.isIon) {
                        var _this_domlessNielsenSdkInstance;
                        (_this_domlessNielsenSdkInstance = this.domlessNielsenSdkInstance) === null || _this_domlessNielsenSdkInstance === void 0 ? void 0 : _this_domlessNielsenSdkInstance.ggPM(this.adaptAgfNielsenBrowserSdkEvents(AgfNielsenBrowserSdkEvents.SET_PLAYHEAD_POSITION), normalizedPosition);
                    } else {
                        this.agfNielsenSdkInstance.ggPM(AgfNielsenBrowserSdkEvents.SET_PLAYHEAD_POSITION, normalizedPosition.toString());
                    }
                }
            }
        },
        {
            key: "stop",
            value: function stop(playerPosition) {
                if (playerPosition) {
                    var normalizedPosition = this.normalisePlayerPosition(playerPosition);
                    if (this.isIon) {
                        var _this_domlessNielsenSdkInstance;
                        (_this_domlessNielsenSdkInstance = this.domlessNielsenSdkInstance) === null || _this_domlessNielsenSdkInstance === void 0 ? void 0 : _this_domlessNielsenSdkInstance.ggPM(this.adaptAgfNielsenBrowserSdkEvents(AgfNielsenBrowserSdkEvents.STOP), normalizedPosition);
                    } else {
                        this.agfNielsenSdkInstance.ggPM(AgfNielsenBrowserSdkEvents.STOP, normalizedPosition.toString());
                    }
                }
            }
        },
        {
            key: "end",
            value: function end(playerPosition) {
                if (playerPosition) {
                    var normalizedPosition = this.normalisePlayerPosition(playerPosition);
                    if (this.isIon) {
                        var _this_domlessNielsenSdkInstance;
                        (_this_domlessNielsenSdkInstance = this.domlessNielsenSdkInstance) === null || _this_domlessNielsenSdkInstance === void 0 ? void 0 : _this_domlessNielsenSdkInstance.ggPM(this.adaptAgfNielsenBrowserSdkEvents(AgfNielsenBrowserSdkEvents.END), normalizedPosition);
                    } else {
                        this.agfNielsenSdkInstance.ggPM(AgfNielsenBrowserSdkEvents.END, normalizedPosition.toString());
                    }
                }
            }
        },
        {
            key: "loadMetadata",
            value: function loadMetadata(metadata, playbackType, nrsMetadata) {
                var adaptedMetadata;
                if (playbackType === PlaybackType.Live) {
                    adaptedMetadata = AgfNielsenMetaAdapter.adaptLiveContentMetadata(metadata);
                } else if (playbackType === PlaybackType.VOD || playbackType === PlaybackType.Preview) {
                    adaptedMetadata = AgfNielsenMetaAdapter.adaptVodContentMetadata(metadata, nrsMetadata);
                } else if (playbackType === PlaybackType.Advert) {
                    adaptedMetadata = AgfNielsenMetaAdapter.adaptAdContentMetadata(metadata);
                } else return;
                if (this.isIon) {
                    var _this_domlessNielsenSdkInstance;
                    (_this_domlessNielsenSdkInstance = this.domlessNielsenSdkInstance) === null || _this_domlessNielsenSdkInstance === void 0 ? void 0 : _this_domlessNielsenSdkInstance.ggPM(this.adaptAgfNielsenBrowserSdkEvents(AgfNielsenBrowserSdkEvents.LOAD_METADATA), adaptedMetadata);
                } else {
                    this.agfNielsenSdkInstance.ggPM(AgfNielsenBrowserSdkEvents.LOAD_METADATA, adaptedMetadata);
                }
            }
        },
        {
            key: "adaptAgfNielsenBrowserSdkEvents",
            value: function adaptAgfNielsenBrowserSdkEvents(agfNielsenBrowserSdkEvent) {
                switch(agfNielsenBrowserSdkEvent){
                    case AgfNielsenBrowserSdkEvents.SET_PLAYHEAD_POSITION:
                        return DomlessNielsenSdkEvents.SET_PLAYHEAD_POSITION;
                    case AgfNielsenBrowserSdkEvents.LOAD_METADATA:
                        return DomlessNielsenSdkEvents.LOAD_METADATA;
                    case AgfNielsenBrowserSdkEvents.END:
                        return DomlessNielsenSdkEvents.END;
                    default:
                        return DomlessNielsenSdkEvents.STOP;
                }
            }
        },
        {
            key: "initializeDomlessNielsenSdkInstance",
            value: function initializeDomlessNielsenSdkInstance() {
                var _this = this;
                if (this.isIon) {
                    this.agfNielsenSdkInstance.then(function(instance) {
                        _this.domlessNielsenSdkInstance = instance;
                    });
                }
            }
        }
    ]);
    return AgfNielsenBrowserSdkClient;
}();

//# sourceMappingURL=agf-nielsen-browser-sdk-client.js.map